<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <o-widget-wrapper
      :schema="schema"
      name="employee"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.employee"
        :items="employeeManagers"
        text-field="full_name"
        value-field="id"
        sort-field="full_name"
        :form-state="formState"
        :loading="optionEmployeeWorking"
        name="employee"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.employee"
        allow-add
        store-name="Employee"
        add-title="Create New"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <employee-form
            :item="item"
            :form-state="formState"
            :server-errors="serverErrors"
            in-modal
          ></employee-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="employee_type"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.employee_type"
        :items="optionCodeEmployeeTypeItems"
        text-field="description"
        value-field="id"
        sort-field="description"
        :form-state="formState"
        :loading="optionCodeEmployeeTypeWorking"
        name="employee_type"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.employee_type"
        allow-add
        store-name="CodeEmployeeType"
        add-title="Create New"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <code-employee-type-form
            :item="item"
            :form-state="formState"
            :server-errors="serverErrors"
            in-modal
          ></code-employee-type-form>
        </template>
      </o-select>
    </o-widget-wrapper>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";

import { default as EmployeeForm } from "../../employee/components/ItemForm";
import { default as CodeEmployeeTypeForm } from "../../code_employee_type/components/ItemForm";
export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("EmployeeManager"),
    CreateCodeTableFetchMixin(["Employee", "CodeEmployeeType", "Group"]),
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,

    EmployeeForm,
    CodeEmployeeTypeForm,
  },
  props: {
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.EmployeeManager, {}),
  }),
  methods: {},
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
    employeeManagers() {
      const manager_group_id = this.optionGroupItems.filter((group) => {
        return group.name === "Manager";
      })[0].id;

      const employee_managers = this.optionEmployeeItems.filter((employee) => {
        if (employee.login) {
          return employee.login.groups.includes(manager_group_id);
        }
      });

      return employee_managers;
    },
  },
  watch: {},
  created() {},
};
</script>
